// extracted by mini-css-extract-plugin
export var NavLinks = "nav-links-module--NavLinks--1f232";
export var NavLinksInline = "nav-links-module--NavLinks--inline--7cba2";
export var NavLinks__item = "nav-links-module--NavLinks__item--27634";